import styled from 'styled-components';
import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const CartItemCount = styled.span`
  position: absolute;
  color: rgb(255, 255, 255);
  top: 2px;
  right: 20px;
  border-radius: 50%;
  font-size: 18px;
  padding: 0px;
  background: rgb(0, 0, 0);
  z-index: 10;
  min-width: 28px;
  text-align: center;
  font-weight: 900;
`;

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    buttonText: {
      color: '#FFFFFF',
      fontWeight: 600,
      marginLeft: '-5px',
      marginRight: '15px',
      alignSelf: 'center',
      textAlign: 'center',
      fontSize: '24px',
      lineHeight: '1.1',
      maxWidth: '180px'
    },
    cartIconBox: {
      height: '45px',
      width: '45px',
      marginTop: '7px',
      marginRight: '-5px'
    },
    overlayContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignContent: 'center',
      borderRadius: '8px',
      backgroundColor: 'white',
      padding: '32px 32px 32px',
      justifyContent: 'space-around',
      boxShadow: '0 3px 9px 0 rgba(0, 0, 0, 0.2)',
      width: 1160,
      maxHeight: 950,
      [theme.breakpoints.down('lg')]: {
        width: 1010
      }
    },
    innerContainer: {
      borderRadius: '8px',
      minWidth: '100%',
      overflow: 'hidden',
      height: '759px',
      background: 'white',
      padding: '32px 32px 40px',
      justifyContent: 'space-between',
      color: '#2A2A2A',
      flexWrap: 'nowrap',
      [theme.breakpoints.down('lg')]: {
        padding: '32px 16px 40px'
      }
    },
    scrollableContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      width: '100%',
      height: '590px'
    },
    cancelButton: {
      maxWidth: 470,
      minWidth: 450,
      [theme.breakpoints.down('lg')]: {
        maxWidth: 460,
        minWidth: 420
      }
    },
    confirmButton: {
      maxWidth: 470,
      minWidth: 450,
      [theme.breakpoints.down('lg')]: {
        maxWidth: 460,
        minWidth: 420
      }
    },
    totalDivider: {
      height: '1px',
      background: '#9B9B9B',
      color: 'white',
      minWidth: '100%',
      margin: '24px 0 16px'
    }
  })
);
